export const formatTabLabel = (label: string) =>
  label.toLowerCase().replace(/\s+/g, '-');
